export default function Hr({ style }) {
  return (
    <hr
      className={style}
      style={{ color: "#000", fontWeight: 500, fontSize: "1.25rem" }}
    />
  );
}
